import { IntegrationRouteParams } from './appRoutes'
import { createRoute, createSubRoute, withSubRoutes } from './routeUtils'
import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

const createMoySkladRoutes = () => {
  // Can't match the old route even partially, because of backwards compatibility redirects
  const baseRoute = '/MoySkladAccount'

  return {
    account: `${baseRoute}`,
    orders: `${baseRoute}/orders`,
    status: `${baseRoute}/status`,
    products: `${baseRoute}/products`,
    settings: `${baseRoute}/settings`,
    attributes: `${baseRoute}/attributes`,
    syncLogs: `${baseRoute}/syncLogs`
  } as const
}

const createMoySkladRoutesOld = () => {
  const baseRoute =
    createRoute<typeof IntegrationType, IntegrationRouteParams>({
      integration: IntegrationType,
      accountId: null
    })`/${'integration'}/${'accountId'}`

  return {
    ...baseRoute,
    orders: createSubRoute(baseRoute, '/orders'),
    settings: withSubRoutes(
      createSubRoute(baseRoute, '/settings'),
      'status', 'products', 'orders', 'configuration', 'additional', 'syncLogs')
  } as const
}

export const moySkladRoutes = {
  MoySklad: createMoySkladRoutes(),
  /**
   * Only for backwards compatibility.
   * NOTE: Also matches {@link storeRoutes.Store} routes.
   */
  MoySkladOld: createMoySkladRoutesOld()
} as const